export default "__VITE_ASSET__o2$dvkYy__"